import { toast } from "sonner";
import { Repeat } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { dayLabel } from "@/lib/dates";

const OfferRow = ({ o, me, canManage, canSign, areaColor, onChange }) => {
  const mine = o.from_user_id === me.id;
  const canTake = !mine && canSign && (!o.to_user_id || o.to_user_id === me.id);
  const act = async (fn, ok) => {
    try {
      const { data } = await fn();
      toast.success(ok, { description: data?.vehicle_note || undefined });
      onChange();
    } catch (e) { toast.error(errMsg(e)); onChange(); }
    window.dispatchEvent(new Event("offers-changed"));
  };
  return (
    <div data-testid={`offer-${o.id}`} className="flex flex-wrap items-center justify-between gap-2 rounded-xl border bg-background/40 p-3 text-sm" style={{ borderLeft: `4px solid ${areaColor || "#FEDC19"}` }}>
      <div className="min-w-0">
        <div className="font-semibold">{dayLabel(o.date)} · {o.template_name} {o.start}–{o.end}</div>
        <div className="text-xs text-muted-foreground">{o.area_name} · {o.position_label} · from {mine ? "you" : o.from_user_name}{o.to_user_name ? ` → ${o.to_user_id === me.id ? "you" : o.to_user_name}` : " → anyone"}{o.note ? ` · "${o.note}"` : ""}</div>
      </div>
      <div className="flex gap-2">
        {canTake && <button onClick={() => act(() => api.post(`/rota/offers/${o.id}/accept`), "Shift is yours")} data-testid={`offer-accept-${o.id}`} className="rounded-full bg-emerald-500 px-4 py-1.5 text-xs font-bold text-white">Take shift</button>}
        {(mine || canManage) && <button onClick={() => act(() => api.delete(`/rota/offers/${o.id}`), "Offer withdrawn")} data-testid={`offer-withdraw-${o.id}`} className="rounded-full border px-3 py-1.5 text-xs">Withdraw</button>}
      </div>
    </div>
  );
};

export const SwapsPanel = ({ offers, me, canManage, canSign, areas, onChange }) => {
  if (!offers.length) return null;
  const forMe = offers.filter((o) => o.to_user_id === me.id).length;
  return (
    <div data-testid="swaps-panel" className="space-y-2 rounded-2xl border border-violet-500/40 bg-violet-500/[0.06] p-4">
      <div className="flex items-center gap-2 text-sm font-bold"><Repeat className="h-4 w-4 text-violet-400" />Shifts up for swap <span className="rounded-full bg-violet-500/30 px-2 text-xs">{offers.length}</span>
        {forMe > 0 && <span data-testid="swaps-for-me" className="rounded-full bg-emerald-500 px-2 text-xs text-white">{forMe} offered to you</span>}</div>
      {offers.map((o) => <OfferRow key={o.id} o={o} me={me} canManage={canManage} canSign={canSign} areaColor={areas.find((a) => a.id === o.area_id)?.color} onChange={onChange} />)}
    </div>
  );
};
